/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {ActionResult} from "@app/ir-q-app-common/types/push-messages";
import type {
	AuditBy,
	DB_Object
} from "@intuitionrobotics/ts-common";
// The subpath, not the package root: the root barrel drags ts-common's whole graph (node-forge
// included) into every browser bundle that imports this module.
import {BadImplementationException} from "@intuitionrobotics/ts-common/core/exceptions";
import type {BaseFact} from "./fact.js";
import type {
	Body_NotifyUpdatedStatuses,
	IncomingCaseManagerMessage,
	IncomingCCMessage
} from "@app/ir-q-app-common/types/message-api";

export type Request_SendMessage = {
	patientIds: string[]
	message: string
	requiresResponse: boolean
};

export const Response_ContactMe = 'Contact Me';
export const Response_Yes = 'Yes';
export const Response_NO = 'No';
export const DefaultResponses = [Response_Yes,
                                 Response_NO,
                                 Response_ContactMe];

export enum MessageDirection {
	OUTGOING = 'OUTGOING',
	INCOMING = 'INCOMING'
}

export type DB_OldMessage = DB_Object & {
	// To be deleted (kasper mId)
	mId?: string
	patientId: string
	// doctorId
	senderId: string
	media?: {
		uri: string
		transcript: string
	}
	direction: MessageDirection
	replyMessageId?: string
	text: string
	status: StatusResult
	responseOptions?: string[]
	_sentAt: AuditBy
	_updated: AuditBy
	conversationId: string
}

export type MessageFact = BaseFact & {
	messageState: string,
	selectedResponse: string | null,
	text: string,
	type: string,
	messageId: string | null;
	responses: string[] | null;
	conversationId: string
}

export enum StatusResult {
	Sent      = 'Sent',
	Delivered = 'Delivered',
	Read      = 'Read',
	Failed    = 'Failed',
	Retried   = 'Retried'
}

export const StatusMap = (result: ActionResult): StatusResult => {
	switch (result) {
		case ActionResult.Sent:
		case ActionResult.Queued:
			return StatusResult.Sent;
		case ActionResult.Read:
		case ActionResult.Success:
			return StatusResult.Delivered;
		case ActionResult.Processed:
			return StatusResult.Read;
		case ActionResult.Error:
			return StatusResult.Failed;
		default:
			throw new BadImplementationException(`Unknown push result ${result}`);
	}
};

export type Request_TranscribeSpeech = {
	gcsUri: string;
};

export type Response_TranscribeSpeech = { results: any[] };

export enum MessageUpdateType {
	NEW = "NEW",
	UPDATE = "UPDATE"
}
export type MessageUpdateData = {
	data: IncomingCCMessage | Body_NotifyUpdatedStatuses | IncomingCaseManagerMessage,
	type: MessageUpdateType
}

export const PushKey_OnMessageUpdate = 'message-update';
export const PushKey_OnMessageUpdateCM = 'message-update-cm';

export const FileKey_MessagingProxy = 'messaging-proxy';
